export default __webpack_public_path__ + "static/media/flor4.e0641173.jpeg";